import { ViewModel,View, ObservableArray } from "binder"
import  { PreOrderListView } from "./preOrderList-view"
import { IImportingPart } from "../../ipart";
import { ImportBillFileDownloader } from "../importBillFileDownloader";
import { FileSelectorViewModel } from "uicomponents";
import { downloadFile } from "src/uicomponents/components/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { stringIsNullOrEmpty } from "src/common/utilities";

export class PreOrderListViewModel extends ViewModel implements IImportingPart{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.items = ObservableArray.create<item>();
        this.title = 'Pre Orders';

    }
    GetDefaultView(): View <ViewModel> {
        return new PreOrderListView();
    }
    public getTypeId(): string {
        return "VM-23D0DD1B-681B-47EB-BED9-507561C54A17"
    }

    
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set items(v: ObservableArray<item>) { this._items = v; } public get items(): ObservableArray<item> { return this._items;} private _items: ObservableArray<item>;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
    private _processId;
    needsProcessToLoad(): boolean {
        return true;
    }
    async load(processId: any): Promise<any> {
        try {
            if(stringIsNullOrEmpty(processId)==false)
                this._processId = processId;
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/ImportProductServices/ListPreOrdersForPurchaseProcess',{
                PurchaseProcessId : this._processId
            });
            this.items.update(...result.PreOrders.map((x,i)=>{
                let r = new item(this);
                r.index= i+1;
                r.processId = this._processId;

                r.providerCode = x.CustomerCode;
                r.providerId = x.CustomerId;
                r.providerName = x.CustomerName;

                r.firstBillId = x.QuotationBillId;
                r.firstBillCode = x.QuotationBillNo;
                r.firstBillTime = x.QuotationTime;
                r.firstFileId = x.QuotationFileId;
                r.firstFileName = x.QuotationFileName;

                r.secondBillId = x.PreOrdersBillId;
                r.secondBillCode = x.PreOrdersBillNo;
                r.secondBillTime = x.PreOrdersTime;
                r.secondFileId = x.PreOrdersFileId;
                r.secondFileName = x.PreOrdersFileName;

                return r;
            }));
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    async save(item:item){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/ImportProductServices/CreateNewPurchasePreOrder',{
                ProviderId : item.providerId,
                PurchaseProcessId : item.processId,
                FileContent : item.secondFileSelector.filecontent,
                FileName : item.secondFileSelector.filename,
                ParentBillId : item.firstBillId,
                Products : item.data.map(x=>{return {
                    MeasuredProductId : x[0],
                    Amount : x[4],
                    Fee : x[5]
                }})
            });
            if(result.IsSuccessful){
                this.messageBoxConfirmSuccess("عملیات موفق","عملیات موفق");
                this.load(null);
            }else{
                this.messageBoxConfirmWarning("عملیات نا موفق","عملیات نا موفق");
                this.isLoading = false;
            }
        } catch (ex) {
            console.log(ex);
            this.messageBoxConfirmWarning("عملیات نا موفق","عملیات نا موفق");
            this.isLoading = false;
        } finally {
        }
    }
    async checkFile(file):Promise<any>{
        try {
            this.isLoading = true;
            let result =await ServerConnection.callServer('/Complex/ImportProductServices/VerifyExcelFile',{
                ExcelFile : file,
                ProductCodeColumn : 1,
                BrandColumn : 2,
                ShallFillColumns : [1,2,3,4],
                NumericColumns : [3,4]
            });
            return result;
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
}


export class item extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:PreOrderListViewModel) {
        super(parent);
        this.downloader = new ImportBillFileDownloader();

        this.firstFileSelector = new FileSelectorViewModel(this);
        this.firstFileSelector.isreadonly = true;
        this.firstFileSelector.downloader = this.downloader;

        this.secondFileSelector = new FileSelectorViewModel(this);
        this.secondFileSelector.onFileChoosed = ()=>this.fileChanged();
        this.secondFileSelector.downloader = this.downloader;

        this._typedParent = parent;
    }

    private _typedParent : PreOrderListViewModel;
    private downloader :ImportBillFileDownloader;
    public set processId(v: string) { this._processId = v; } public get processId(): string { return this._processId;} private _processId: string;
    

    public set index(v: number) { this._index = v; } public get index(): number { return this._index;} private _index: number;

    public set providerId(v: string) { this._providerId = v; } public get providerId(): string { return this._providerId;} private _providerId: string;
    public set providerName(v: string) { this._providerName = v; } public get providerName(): string { return this._providerName;} private _providerName: string;
    public set providerCode(v: string) { this._providerCode = v; } public get providerCode(): string { return this._providerCode;} private _providerCode: string;

    public set firstBillId(v: string) { 
        this._firstBillId = v;
        this.downloader.purchaseBillId = v;
    } public get firstBillId(): string { return this._firstBillId;} private _firstBillId: string;
    public set firstBillCode(v: string) { this._firstBillCode = v; } public get firstBillCode(): string { return this._firstBillCode;} private _firstBillCode: string;
    public set firstBillTime(v: string) { this._firstBillTime = v; } public get firstBillTime(): string { return this._firstBillTime;} private _firstBillTime: string;
    public set firstFileId(v: string) { 
        this._firstFileId = v; 
        this.firstFileSelector.fileid = v;
    } public get firstFileId(): string { return this._firstFileId;} private _firstFileId: string;
    public set firstFileName(v: string) { 
        this._firstFileName = v; 
        this.firstFileSelector.filename = v;
    } public get firstFileName(): string { return this._firstFileName;} private _firstFileName: string;
    public set firstFileSelector(v: FileSelectorViewModel) { this._firstFileSelector = v; } public get firstFileSelector(): FileSelectorViewModel { return this._firstFileSelector;} private _firstFileSelector: FileSelectorViewModel;
    

    public set secondBillId(v: string) { 
        this._secondBillId = v;
        this.downloader.purchaseBillId = v;
    } public get secondBillId(): string { return this._secondBillId;} private _secondBillId: string;
    public set secondBillCode(v: string) { this._secondBillCode = v; } public get secondBillCode(): string { return this._secondBillCode;} private _secondBillCode: string;
    public set secondBillTime(v: string) { this._secondBillTime = v; } public get secondBillTime(): string { return this._secondBillTime;} private _secondBillTime: string;
    public set secondFileId(v: string) { 
        this._secondFileId = v; 
        this.secondFileSelector.fileid = v;
    } public get secondFileId(): string { return this._secondFileId;} private _secondFileId: string;
    public set secondFileName(v: string) { 
        this._secondFileName = v; 
        this.secondFileSelector.filename = v;
    } public get secondFileName(): string { return this._secondFileName;} private _secondFileName: string;
    public set secondFileSelector(v: FileSelectorViewModel) { this._secondFileSelector = v; } public get secondFileSelector(): FileSelectorViewModel { return this._secondFileSelector;} private _secondFileSelector: FileSelectorViewModel;
    

    public data:string[][];
    private async fileChanged(){
        try {
            let result =await this._typedParent.checkFile(this.secondFileSelector.filecontent);
            if(result.IsValid){
                this.data = result.Data;
                this.messageBoxConfirmSuccess("فایل بررسی و صحیح است.","صحت فایل")
            }else{
                downloadFile(result.InvalidFileInfo,'مشکلات.xlsx');
                this.messageBoxConfirmWarning('ساختار فایل صحیح نیست','خطا در فایل');
            }
        } catch (ex) {
            console.log(ex);
            this.messageBoxConfirmWarning('خطا در ارتباط','خطا در ارتباط');
        } finally {
        }
    }

    async save(){
        this._typedParent.save(this);
    }
}